module.exports = __webpack_public_path__ + "01_bob_brown.d8a38c12.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/01_bob_brown.png
// module id = 7FFU
// module chunks = 0